import { render } from "./withAuthLayout.vue?vue&type=template&id=6ae0828f"
import script from "./withAuthLayout.vue?vue&type=script&lang=js"
export * from "./withAuthLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__